import React from 'react';
import { FlameIcon } from 'lucide-react';
const TOTAL = 100;
const REMAINING = 7;
type ScarcityBarProps = {
  dark?: boolean;
};
export function ScarcityBar({
  dark = false
}: ScarcityBarProps) {
  const filled = (TOTAL - REMAINING) / TOTAL * 100;
  return <div className="w-full max-w-md" data-id="element-51" data-mp="2l33gi48zlota">
      <div className="mb-2 flex items-center justify-between gap-2 text-sm font-bold" data-id="element-52" data-mp="2q37n92k3f56b">
        <span className={`flex items-center gap-1.5 ${dark ? 'text-white' : 'text-ink'}`} data-id="element-53" data-mp="2b68jjpsd3wh4">
          <FlameIcon className="h-4 w-4 text-alert" aria-hidden="true" data-id="element-54" data-mp="2g5l9ijej5jnx" />
          Only <span className="text-alert" data-id="element-55" data-mp="2g3gv37j0929e">{REMAINING} spots</span> left
        </span>
        <span className={dark ? 'text-white/70' : 'text-ink/60'} data-id="element-56" data-mp="227wo9agjwaic">{Math.round(filled)}% claimed</span>
      </div>
      <div className={`h-4 w-full overflow-hidden rounded-full ${dark ? 'bg-white/15' : 'bg-navy-900/10'}`} role="progressbar" aria-valuenow={Math.round(filled)} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-57" data-mp="276zrcpcz06no">
        <div className="bar-stripes h-full rounded-full bg-alert" style={{
        width: `${filled}%`
      }} data-id="element-58" data-mp="33ksapi2xmlsk" />
      </div>
      <p className={`mt-2 text-center text-xs ${dark ? 'text-white/70' : 'text-ink/60'}`} data-id="element-59" data-mp="3dcoixlyqfsai">
        When these {REMAINING} spots are gone, the promotional $27 price closes.
      </p>
    </div>;
}